import * as activityApi from "@/api/activity";
import { ActivityTagHotSceneEnum, ActivityTagGroupSceneEnum } from '@/utils/HdbConsts'
const activity = {
  state: {
    allSkinTags: null,
    allSkinTagsFetching: false,
    hotTags: null,
    hotTagsFetching: false,
    headerRootHeight: 0,
    headerSearchBoxVisible: false
  },

  mutations: {
    setAllSkinTags: (state, allSkinTags) => {
      state.allSkinTags = allSkinTags
    },
    setAllSkinTagsFetching: (state, allSkinTagsFetching) => {
      state.allSkinTagsFetching = allSkinTagsFetching
    },
    setHotTags: (state, hotTags) => {
      state.hotTags = hotTags
    },
    setHotTagsFetching: (state, hotTagsFetching) => {
      state.hotTagsFetching = hotTagsFetching
    },
    setHeaderRootHeight: (state, headerRootHeight) => {
      // console.log("headerRootHeight: " + headerRootHeight)
      state.headerRootHeight = headerRootHeight
    },
    setHeaderSearchBoxVisible: (state, headerSearchBoxVisible) => {
      // console.log("setHeaderSearchBoxVisible: " + headerSearchBoxVisible)
      state.headerSearchBoxVisible = headerSearchBoxVisible
    }
  },

  actions: {
    async fetchAllSkinTags({ commit, state }) {
      if (state.allSkinTagsFetching) {
        return
      }
      if (state.allSkinTags && state.allSkinTags.length > 0) {
        return
      }
      try {
        commit('setAllSkinTagsFetching', true)
        const res = await activityApi.mmsActivityTagSetList({
          tagGroupScenes: [ActivityTagGroupSceneEnum.SKIN_TAG.id],
          sortField: 'sort_num',
          sortOrder: 'asc'
        })
        if (!!res && res.code === 0) {
          commit('setAllSkinTags', res.data)
        }
      } finally {
        commit('setAllSkinTagsFetching', false)
      }
    },

    async fetchHotTags({ commit, state }) {
      if (state.hotTagsFetching) {
        return
      }
      if (state.hotTags && state.hotTags.length > 0) {
        return
      }
      try {
        commit('setHotTagsFetching', true)
        const res = await activityApi.mmsActivityTagHotList({
          scenes: [
            ActivityTagHotSceneEnum.SKIN_HOT_SEARCH.id,
            ActivityTagHotSceneEnum.SKIN_SEARCH_RECOMMEND.id
          ]
        })
        if (!!res && res.code === 0) {
          commit('setHotTags', res.data)
        }
      } finally {
        commit('setHotTagsFetching', false)
      }
    }
  }
}

export default activity
